import { env } from './env';

/**
 * 앱 경로(`APP_PATH`, 라우터가 보는 경로) ↔ 브라우저 주소. 기준 경로(`env.basePath`)만 붙이고 뗀다.
 * 서비스는 `/` 라 그대로다. 경로 아래에 올리면(프리뷰 `/d3-dashboard/`) 하드 네비게이션 · 주소 바꾸기가 그 아래에 머문다.
 */
const prefix = (basePath: string) => basePath.replace(/\/$/, '');

/** `/login` → `<기준>/login`. 하드 네비게이션 · history 에 넘길 주소 */
export function toBrowserPath(appPath: string, basePath: string = env.basePath): string {
  return `${prefix(basePath)}${appPath}`;
}

/** 지금 브라우저 주소의 앱 경로(경로 + 검색 + 해시). 기준 경로 밖이면 그대로 */
export function currentAppPath(
  location: Pick<Location, 'pathname' | 'search' | 'hash'> = window.location,
  basePath: string = env.basePath,
): string {
  const base = prefix(basePath);
  const { pathname } = location;
  const inside =
    base && (pathname === base || pathname.startsWith(`${base}/`))
      ? pathname.slice(base.length) || '/'
      : pathname;
  return `${inside}${location.search}${location.hash}`;
}
